// extracted by css-extract-rspack-plugin
export default {"cls1":"TrendAdornment-cls1_9wE","cls2":"TrendAdornment-cls2_Q70 TrendAdornment-cls1_9wE"};